import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';

import { injectIntl } from 'react-intl';

import { isTouchScreen } from '../helpers';
import Footer from '@client/components/footer';
import Header from '@client/components/header';

import '../styles/core.scss';

/* eslint-disable react/prefer-stateless-function */
@injectIntl
export default class GuestLayout extends React.Component {
    render() {
        const {
            intl
        } = this.props;

        return (
            <div
                id="inner-wrapper"
                className={classNames('brand-color', `${this.getPageClassName()}-page`,
                    {
                        'touch-device': isTouchScreen(),
                        'not-touch-device': !isTouchScreen()
                    }
                )}
            >
                <Helmet
                    title={intl.formatMessage({ id: 'meta.title' })}
                    meta={[
                        { name: 'description', content: intl.formatMessage({ id: 'meta.description' }) },
                        { name: 'keywords', content: intl.formatMessage({ id: 'meta.keywords' }) }
                    ]}
                />
                <Header location={this.props.location} isGuest />
                {this.props.children}
                <Footer isGuest={true} />
            </div>
        );
    }

    getPageClassName() {
        return this.props.location.pathname.split('/')[1];
    }
}

GuestLayout.propTypes = {
    children: PropTypes.element,
    location: PropTypes.object,
    intl: PropTypes.object
};
